<td-wb-detailed-loading-indicator [displayDelay]="0" />
